// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"8028bf2e","218":"8028bf2e","616":"e7135a89","725":"e05cdc56","838":"8028bf2e"}[chunkId] + ".chunk.css";
};